import { render } from "./vehicleDetails.vue?vue&type=template&id=6074bf52&scoped=true"
import script from "./vehicleDetails.vue?vue&type=script&lang=js"
export * from "./vehicleDetails.vue?vue&type=script&lang=js"

import "./vehicleDetails.vue?vue&type=style&index=0&id=6074bf52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6074bf52"]])

export default __exports__